import ManageCultureTable from './ManageCultureTable'

export default ManageCultureTable
